import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";

import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

import api from "../service/api";
import { setError, setWarning } from "../reducers/appSlice";
import Modal from "../components/Modal";

const VerificarFirma = (props) => {
  const { adjuntoId, nombreAdjunto, disabled } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [firmas, setFirmas] = useState([]);

  const handleOpen = () => {
    setSubmitting(true);
    api
      .verificarFirmaAdjunto({ adjuntoId: adjuntoId })
      .then((res) => {
        if (res.data.firmas.length > 0) {
          setFirmas(res.data.firmas);
          setOpen(true);
        } else {
          dispatch(setWarning("El documento no posee firmas"));
        }
      })
      .catch((e) =>
        dispatch(
          setError(e.response.data.error ? e.response.data.error : "Error")
        )
      )
      .finally(() => setSubmitting(false));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        title="Verificar firma"
        size="small"
        onClick={handleOpen}
        disabled={disabled || submitting}
      >
        <FactCheckOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm" closeButton>
        <Typography variant="titulo" paragraph>
          VALIDACIÓN FIRMA DIGITAL
        </Typography>

        <Typography variant="cuerpo" paragraph>
          <b>Adjunto: {nombreAdjunto}</b>
        </Typography>

        {firmas.map((firma, indice) => {
          return (
            <>
              <Typography variant="cuerpo">
                Firmado por <b>{firma.nombre}</b> el día {firma.fecha}
              </Typography>
              <br></br>
              <Typography
                variant="cuerpo"
                sx={!firma.integridad ? { color: "red" } : {}}
              >
                {firma.integridad ? (
                  <>
                    {firma.total
                      ? "La firma se corresponde con el documento firmado"
                      : "La firma cubre solamente parte del documento"}
                  </>
                ) : (
                  "El documento no es válido"
                )}
              </Typography>
              <br></br>

              <Typography
                variant="cuerpo"
                sx={firma.cadena ? {} : { color: "red" }}
              >
                {firma.cadena
                  ? "La identidad del firmante es válida"
                  : "No se pudo validar la identidad del firmante"}
              </Typography>
              <br></br>
              {firmas.length === indice + 1 ? (
                ""
              ) : (
                <Divider sx={{ mt: 1, mb: 1 }} />
              )}
            </>
          );
        })}
      </Modal>
    </>
  );
};

VerificarFirma.propTypes = {
  adjuntoId: PropTypes.number.isRequired,
  nombreAdjunto: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

VerificarFirma.VerificarFirma = {
  disabled: false,
};

export default VerificarFirma;
